import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class font
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.font = {};

/**
 * GET Endpoint `/font/list`
 * @param {boolean} show_hidden
 * @param {boolean} show_private
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.font
 */
ReachAPI.font.getList = function (show_hidden, show_private) {
    show_hidden = Boolean(show_hidden);
    show_private = Boolean(show_private);

    var cache_id =
        '/fonts/show_hidden=' +
        (show_hidden ? 'true' : 'false') +
        '/show_private=' +
        (show_private ? 'true' : 'false');
    var url = ReachAPI.server + '/font/list/';
    var params = {
        show_hidden: show_hidden,
        show_private: show_private,
    };
    var jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Font List from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Font List from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Font List',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/font/list/player`
 * @param {string} player_uuid
 * @param {boolean} show_hidden
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.font
 */
ReachAPI.font.getListPlayer = function (player_uuid, show_hidden) {
    show_hidden = Boolean(show_hidden);

    var cache_id =
        '/fonts/player=' + player_uuid + '/show_hidden=' + (show_hidden ? 'true' : 'false');
    var url = ReachAPI.server + '/font/list/player/' + player_uuid;
    var params = {
        show_hidden: show_hidden,
    };
    var jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                "Retrieved Player's Font List from the CACHE (API call failed)",
                null,
                __fileline
            );
        } else {
            Log.Debug("Retrieved Player's Font List from the API", null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            "Failed to retrieve Player's Font List",
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
